<template>
  <div
    class="services-landing__alpha-desktop-wrapper"
    v-if="items && items.length > 0"
  >
    <div class="container">
      <template
        v-for="(group, index) in groupedItems"
        :key="index"
      >
        <div
          class="services-landing__group"
          :id="group.letter"
        >
          <div class="services-landing__group-header">
            {{ group.letter }}
          </div>
          <ul class="services-landing__group-items">
            <li
              v-for="(item, itemIndex) in group.items"
              :key="itemIndex"
              class="services-landing__second-level-desktop-item"
              :id="item.id"
              @click="setActive(item)"
            >
              <div
                class="services-landing__third-level-desktop-item-inner"
                :class="{
                  'services-landing__third-level-desktop-item-inner--active':
                    active && active.id === item.id,
                }"
              >
                {{ item.title }}
              </div>
            </li>
          </ul>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { store } from "../../store.js";

export default {
  props: ["items"],
  components: {},
  data() {
    return {
      active: null,
    };
  },
  computed: {
    groupedItems() {
      if (!this.items || this.items.length === 0) {
        return [];
      }

      // Create an object to store items by their first letter
      const grouped = this.items.reduce((acc, item) => {
        const firstLetter = item.title.charAt(0).toUpperCase();
        if (!acc[firstLetter]) {
          acc[firstLetter] = [];
        }
        acc[firstLetter].push(item);
        return acc;
      }, {});

      // Convert the grouped object into an array of objects with letter and items
      return Object.entries(grouped).map(([letter, items]) => ({
        letter,
        items,
      }));
    },
  },
  methods: {
    setActive: function (item) {
      this.active = item;
      store.serviceOverview = item;
      this.$nextTick(() => {
        if (document.querySelector(".services__overview")) {
          var element = document.querySelector(".services__overview");

          var headerOffset = 100;
          var elementPosition = element.getBoundingClientRect().top;
          var offsetPosition =
            elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
        }
      });
    },
  },
};
</script>
